import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { Login } from './pages/login/login';
import { ProspectDetail } from './pages/prospect-detail/prospect-detail';
import { Prospects } from './pages/prospects/prospects';
import { AccountDetail } from './pages/account-detail/account-detail';
import { Accounts } from './pages/accounts/accounts';
import { ContactDetail } from './pages/contact-detail/contact-detail'; 
import { Contacts } from './pages/contacts/contacts';
import { OpportunitiesDetail } from './pages/opportunities-detail/opportunities-detail';
import { OpportunitiesDetailTable } from './pages/opportunities-detail-table/opportunities-detail-table'; 
import { FunctionDetailTable } from './pages/function-detail-table/function-detail-table';
import { Opportunities } from './pages/opportunities/opportunities';
import { OpportunitiesGeneral } from './pages/opportunities-generalview-table/opportunities-generalview-table';
import { Budget } from './pages/budget/budget';
import { BudgetDetail } from './pages/budget-detail/budget-detail';
import { BudgetDetailTable } from './pages/budget-detail-table/budget-detail-table';
import { BudgetPdfTable } from './pages/budget-pdf-table/budget-pdf-table';
import { BudgetVersionTable } from './pages/budget-version/budget-version-table';
import { UserTable } from './pages/user-table/user-table';
import { Goalstable } from './pages/goals/goals';
import { Task } from './pages/task/task';
import { TaskDetail } from './pages/task-detail/task-detail';
import { GoalsGraphicComponent } from './pages/goals-graphic/goals-graphic';
import { Contract } from './pages/contract/contract';
import { ContractDetail } from './pages/contract-detail/contract-detail';
import { ContractDetailTable } from './pages/contract-detail-table/contract-detail-table';
import { Calendar } from './pages/calendar/calendar';
import { Forecast } from './pages/forecast/forecast';
import { MainPage } from './pages/main-page/main-page';
import { Campaigns } from './pages/campaigns/campaigns';
import { Segments } from './pages/segments/segments';
import { ForecastGraphic } from './pages/forecast-graphic/forecast-graphic';
import { CampaignMembers } from './pages/campaign-members/campaign-members';
import { CampaignDetail } from './pages/campaign-detail/campaign-detail';

import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
    {path: '', component: MainPage, canActivate: [AuthGuard]},
    {path: 'login', component: Login},
    {path: 'home', component: Home, canActivate: [AuthGuard]},
    {path: 'home-page',component:MainPage, canActivate: [AuthGuard]},
    {path: 'prospect/:id', component: ProspectDetail, canActivate: [AuthGuard]},
    {path: 'prospects', component: Prospects, canActivate: [AuthGuard]},
    {path: 'accounts', component: Accounts, canActivate: [AuthGuard]},
    {path: 'account/:id', component: AccountDetail, canActivate: [AuthGuard]},
    {path: 'contacts', component: Contacts, canActivate: [AuthGuard]},
    {path: 'contact/:id', component: ContactDetail, canActivate: [AuthGuard]},
    {path: 'opportunities-detail-table', component: OpportunitiesDetailTable, canActivate: [AuthGuard]},
    {path: 'contact-functions/:id', component: FunctionDetailTable, canActivate: [AuthGuard]},
    {path: 'opportunity/:id', component: OpportunitiesDetail, canActivate: [AuthGuard]},
    {path: 'opportunities', component: Opportunities, canActivate: [AuthGuard]},
    {path: 'opportunities-generalview', component: OpportunitiesGeneral, canActivate: [AuthGuard]},
    {path: 'budget', component:Budget, canActivate: [AuthGuard]},
    {path: 'budget/:id', component:BudgetDetail, canActivate: [AuthGuard]},
    {path: 'budget-detail-table', component: BudgetDetailTable, canActivate: [AuthGuard]},
    {path: 'budget-pdf-table', component: BudgetPdfTable, canActivate: [AuthGuard]}, 
    {path: 'budget/:id/budget-version-table', component: BudgetVersionTable, canActivate: [AuthGuard]},
    {path: 'user-table', component: UserTable, canActivate: [AuthGuard]},
    {path: 'goals', component: Goalstable, canActivate: [AuthGuard]},
    {path: 'tasks', component: Task, canActivate: [AuthGuard]},
    {path: 'task/:id',component:TaskDetail, canActivate: [AuthGuard]},
    {path: 'goals-graphic', component:GoalsGraphicComponent, canActivate: [AuthGuard]},
    {path: 'contracts', component:Contract, canActivate: [AuthGuard]},
    {path: 'contracts/:id', component:ContractDetail, canActivate: [AuthGuard]},
    {path: 'contracts-detail-table', component:ContractDetailTable, canActivate: [AuthGuard]},
    {path: 'calendar', component: Calendar, canActivate: [AuthGuard]},
    {path: 'forecast', component:Forecast, canActivate: [AuthGuard]},
    {path: 'campaigns', component:Campaigns, canActivate: [AuthGuard]},
    {path: 'segments', component:Segments, canActivate: [AuthGuard]},
    {path: 'forecast-graphic', component:ForecastGraphic, canActivate: [AuthGuard]},
    {path: 'campaigns/members/:id', component:CampaignMembers, canActivate: [AuthGuard]},
    {path: 'campaign/detail/:id', component:CampaignDetail, canActivate: [AuthGuard]}
];